<template>
  <div class="header_cont" :style="updateWidth()">
    <div class="left cur" @click="jumpIndex">
      <img class="login_img" src="@/assets/img/logo1.png"/>
    </div>

    <div class="right flex_center">
      <el-tooltip effect="dark" content="转换框" placement="bottom">
        <div class="item cur" @click="transitionBox = true">
          <svg t="1730857566351" style="width:2.8rem;height:2.8rem" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4254"><path d="M911.182027 898.238738 755.794004 729.695091c-0.11768-0.12382-0.25378-0.208754-0.370437-0.330528 73.567529-70.137407 119.567189-168.960133 119.567189-278.395568 0-212.18254-172.626639-384.805086-384.804063-384.805086-212.18561 0-384.806109 172.621523-384.806109 384.805086 0 212.18254 172.621523 384.804063 384.806109 384.804063 75.575256 0 146.07082-21.988804 205.589378-59.774385 1.055029 1.937119 2.270716 3.800559 3.836375 5.496178l155.39007 168.539554c10.211573 11.081383 27.482935 11.784394 38.561247 1.571798l16.054651-14.806217C920.702867 926.585343 921.395646 909.319098 911.182027 898.238738zM154.504398 450.968995c0-185.094602 150.585647-335.681272 335.681272-335.681272 185.090509 0 335.681272 150.58667 335.681272 335.681272 0 185.094602-150.590763 335.681272-335.681272 335.681272C305.090045 786.65129 154.504398 636.063597 154.504398 450.968995z" fill="#404664" p-id="4255"></path></svg>
        </div>
      </el-tooltip>

      <div class="item" @click="pullFn" v-if="$ipad">
        <img class="cur sceen" src="@/assets/img/sceen.png" />
      </div>

      <el-tooltip effect="dark" content="全屏" placement="bottom" v-else>
        <div class="item" @click="pullFn">
          <img class="cur sceen" src="@/assets/img/sceen.png" />
        </div>
      </el-tooltip>
      
      <el-popover
          placement="bottom"
          width=""
          trigger="hover">
          <img slot="reference" class="cur phone" src="@/assets/img/phone.png" />
          <div class="code_cont flex_center_center">
            <img class="code_img" src="@/assets/img/wxqrcode.jpg" />
            <p class="code_text">学生端</p>
          </div>
      </el-popover>

      <div class="item" @click="noticeFn" v-if="$ipad">
        <el-badge :value="unreadNumber" :hidden="unreadNumber == 0">
          <img class="cur infom" src="@/assets/img/infom.png" />
        </el-badge>
      </div>
      <el-tooltip effect="dark" content="公告" placement="bottom" v-else>
        <div class="item" @click="noticeFn">
          <el-badge :value="unreadNumber" :hidden="unreadNumber == 0">
            <img class="cur infom" src="@/assets/img/infom.png" />
          </el-badge>
        </div>
      </el-tooltip>
      
      <el-popover placement="bottom" trigger="hover" popper-class="poper_info">
          <div class="poper_cont">
              <p class="text1 cur" v-if="userInfo" @click="goUserCenter">{{ userInfo.name }}</p>
              <p class="text2 cur" @click="wordsFn">我的词库</p>
              <p class="text3 cur" @click="loginOutFun()">退出登录</p>
          </div>

          <div class="user cur"  slot="reference">
              <el-avatar
                  fit="fill"
                  style="width:3.5rem;height:3.5rem"
                  :src="userInfo && userInfo.portrait ? userInfo.portrait.url : ''"
              />
              
              <i class="el-icon-arrow-down" size="16" style="margin-left: 5px;font-size: 2rem"></i>
          </div>
      </el-popover>
    </div>


    <el-dialog
        width="30%"
        title="转换框"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :visible.sync="transitionBox"
        :close-on-press-escape="false"
        @close="wordInfolist = {},searchValue = ''"
    >
        <div style="display:flex;flex-direction:column;height:55rem">
          <el-input placeholder="请输入单词/句子/翻译" class="xx-input" v-model="searchValue" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" />
          <div style="display:flex;margin:1rem 0 .5rem;align-items:center;justify-content:space-between">
            <p style="font-size:1.5rem;color:#c7cad1">检索结果 {{ wordInfolist.length }} 词</p>
            <el-button class="xx-button" type="primary" @click="onSearch" :loading="searchloadong">搜索</el-button>
          </div>

          <div style="display:flex;flex-direction:column;overflow-y:auto;margin-top:3rem;flex:1" class="xx-scroll">
              <div style="text-align:center;border:1px solid #eee;border-bottom:none">
                  <div style="display:flex">
                      <p style="border-bottom:1px solid #eee;border-right:1px solid #eee;padding:10px 0;flex:1">单词</p>
                      <p style="border-bottom:1px solid #eee;border-right:1px solid #eee;padding:10px 0;flex:1">音标</p>
                      <p style="border-bottom:1px solid #eee;padding:10px 0;flex:1">直注音标</p>
                  </div>

                  <div style="display:flex;border-bottom:1px solid #eee" v-if="!wordInfolist?.length">
                      <p style="padding:2rem 0;border-right:1px solid #eee;flex:1">
                          <empty type="2" text="空空如也~" />
                      </p>
                  </div>
                  
                  <template v-else>
                      <div style="display:flex;border-bottom:1px solid #eee" v-for="item in wordInfolist" :key="item.id">
                          <p style="font-size:2rem;padding:8px;border-right:1px solid #eee;flex:1;display:flex;align-items:center;justify-content:center">{{ item.word }}</p>
                          <p style="font-size:2rem;padding:8px;border-right:1px solid #eee;flex:1;display:flex;align-items:center;justify-content:center">{{ item.soundmark || '--' }}</p>
                          <p @click="onCopy(item.specialSoundmark)" :class="{ cur: item.specialSoundmark }" :style="`${item.specialSoundmark ? 'font-family:specialWord;' : ''}font-size:2${item.specialSoundmark ? '.5' : ''}rem;padding:8px;flex:1;display:flex;align-items:center;justify-content:center`">{{ item.specialSoundmark ? removeBrackets(item.specialSoundmark) || '[ ]' : '--' }}</p>
                      </div>
                  </template>
              </div>
          </div>
        </div>

        <div style="height:2rem"></div>
        <div style="display:flex;justify-content:space-between;align-items:center">
          <p style="font-size:1.5rem;color:#c7cad1">最多搜索100条~</p>
          <el-button type="primary" @click="onAllCopy" plain>一键复制直注音标</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { removeBrackets } from '@/utils/index.js'
import {mapState} from 'vuex';
import { loginOut } from '@/api/auth';
import { messageUnreadCount } from '@/api/message';
import { specialSoundmark } from '@/api/config';
export default {
  name: "Header",
  data() {
    return {
      showCockpit: false,
      unreadNumber: 0,

      removeBrackets,        /** 去除括号 */
      wordInfolist: [],      /** 单词信息 */
      searchValue: '',       /** 搜索框值 */
      transitionBox: false,  /** 转换框状态 */
      searchloadong: false,  /** 搜索框加载状态 */
    };
  },

  computed: {
    ...mapState({
        userInfo: state => state.user.userInfo,
        menuSate: state => state.user.menuState,
        fullState:state => state.user.fullState
    }),
  },

  mounted() {
    this.getUnReadNumber()
  },

  methods: {
    /** 搜索音标 */
    async onSearch() {
        if (!this.searchValue) {
            this.$message.warning('请输入单词/句子/翻译');
            this.wordInfolist = [];
            return;
        };

        this.searchloadong = true;
        try {
            const result = await specialSoundmark({ 
                limit: 100,
                word: this.searchValue,
            });

            this.wordInfolist = result.data;
            if (!this.wordInfolist.length) {
              this.$message.warning('暂未搜索到相关音标');
            };

        } catch (error) {
          
        } finally {
            this.searchloadong = false;
        }
    },

    /** 复制 */
    onCopy(value) {
        if (!value) {
            return;
        };

        try {
            navigator.clipboard.writeText(value);
            this.$message.success('复制成功');

        } catch (error) {
            const textarea = document.createElement('textarea');
            textarea.value = value;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            this.$message.success('复制成功');
        };
    },
	  
	  /** 一键复制所有直注音标 */
	  onAllCopy() {
			const result = this.wordInfolist.reduce((text, item) => text + removeBrackets(item.specialSoundmark) + ' ', '').slice(0, -1);
			if (!result) {
				this.$message.error('暂无音标可复制');
				return;
			};
			
		  try {
			  navigator.clipboard.writeText(result);
			  this.$message.success('复制成功');
			  
		  } catch (error) {
			  const textarea = document.createElement('textarea');
			  textarea.value = result;
			  document.body.appendChild(textarea);
			  textarea.select();
			  document.execCommand('copy');
			  document.body.removeChild(textarea);
			  this.$message.success('复制成功');
		  };
	  },

    pullFn(){
      this.$store.commit('user/setFull',true)
      this.$store.commit('user/setfullState',0)
    },

    updateWidth() {
      let w = "100%";
      let num = this.menuSate?'30rem':'18rem'
      return { width: `calc(${w} - ${num})` };
    },

    loginOutFun() {
      loginOut().then(res => {
        if (res.error == 0) {
          this.$store.commit('user/logout')
          this.$router.push('/login')
          localStorage.removeItem('tips')
          sessionStorage.setItem('change',false)
        }else{
          this.$message.error(res.message)
        }
      })
    },

    /** 获取未读消息数 */
    getUnReadNumber() {
        messageUnreadCount().then(res => {
          if (res.error == 0) {
              this.unreadNumber = res.data
              console.log('消息数', this.unreadNumber)
          }
        })
    },

    noticeFn() {
      if (this.$route.fullPath == "/message") {
          return;
      };

      this.$router.push('/message')
    },

    wordsFn() {
      if (this.$route.fullPath == "/test/mywords") {
          return;
      };

      this.$router.push('/test/mywords')
    },

    jumpIndex() {
      if (this.$route.fullPath == "/index") {
          return;
      };

      this.$router.push({
        path: "/index",
      });
    },

    goUserCenter() {
      if (this.$route.fullPath == "/myzoe") {
          return;
      };

      this.$router.push({
        path: "/myzoe",
      });
    }
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/mixins.scss";
.xx-input ::v-deep .el-input-group__append{border:none !important}
.xx-button{width:87px !important}
.xx-scroll {
  &::-webkit-scrollbar {
      width: 6px;
      height: 1px;
  }
  /* 滑块部分 */
  &::-webkit-scrollbar-thumb { 
      border-radius: 5px;
      background-color:#0B9AFF;
  }
  /* 轨道部分 */
  &::-webkit-scrollbar-track { 
      background: #fff;
      border-radius: 5px;
  }
}

.header_cont {
  position: fixed;
  padding: 0.2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  box-sizing: border-box;
  padding: 1.5rem 8rem 1.5rem 2.4rem;
  transition: width .3s;
  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    // img {
    //   height: 0.56rem;
    // }
   .login_img{
    width: 21.58rem;
    height: 6.4rem;
   }
    .title_name {
      font-weight: bold;
      color: #fff;
      font-size: 2.4rem;
      color: #1A1A1A;
      margin-left: 3px;
    }
  }
  .right {
  //  width: 16rem;
   .phone,.item{
    margin-right: 3.2rem;
   }
   .phone,.infom,.sceen{
     width: 2.8rem;
     height: 2.8rem;
   }
   .phone:hover{
    content: url(@/assets/img/phone_1.png);
   }
   .infom:hover{
    content: url(@/assets/img/infom_1.png);
   }
   .sceen:hover{
    content: url(@/assets/img/sceen_1.png);
   }
   .user{
    display: flex;
    align-items: center;
    font-size: 4px;
    &:hover{
      color: #0B9AFF;
    }
   }
  }
  .guide-btn {
    font-size: 0.18rem;
    padding: 0.09rem 0.15rem;
  }
}
.code_cont{
  // padding: 10px;
  box-sizing: border-box;
  .code_img{
    width: 14.8rem;
    height: 14.8rem;
  }
  .code_text{
    font-size: 1.4rem;
    color: #626780;
    margin-top: 1.5rem;
  }
}
.poper_cont{
  // width: 124px;
  text-align: center;
  color: #3A3F5E;
  font-size: 1.8rem;
  
  .text1{
    padding-bottom: 12px;
    &:hover{
      color: #0B9AFF;
    }
  }
  .text2{
    padding: 12px 0;
    border-top: 1px solid #F0F2F4;
    border-bottom: 1px solid #F0F2F4;
    &:hover{
      color: #0B9AFF;
    }
  }
  .text3{
    padding-top: 12px;
    &:hover{
      color: #0B9AFF;
    }
  }
}
</style>
